import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export function CtaSection() {
  return (
    <section className="bg-blue-700 py-16 lg:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center lg:px-8">
        <h2 className="text-balance text-3xl font-bold text-white md:text-4xl">
          Ready to Transform Your Business?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-pretty text-lg leading-relaxed text-white">
          Join hundreds of shop owners who have already taken control of their
          sales, inventory, and finances with Shop Kiganjani.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <a href="/login">
            <button className="inline-flex items-center gap-2 bg-[hsl(0,0%,100%)] text-blue-600 px-8 py-3 rounded-lg font-semibold text-base transition-all duration-300 hover:bg-[hsl(0,0%,95%)] hover:scale-105 shadow-md">
              Start Now
              <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
            </button>
          </a>
          <a href="#services">
            <button className="inline-flex items-center gap-2 border border-white/30 bg-transparent text-white px-8 py-3 rounded-lg font-semibold text-base transition-all duration-300 hover:bg-white/10 hover:text-white hover:scale-105">
              Learn More
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}